export function toCalendarControlFriendlyDate(date:Date):string {
    return date.toISOString().substring(0, 10);
}

/* Event dates are calendar days, not instants. Inclusive of the end date itself. */
export function isEventOver(endDate: string | Date | null | undefined): boolean {
    if (!endDate) return false;

    let endDay = '';
    if (endDate instanceof Date) {
        const year = endDate.getUTCFullYear();
        const month = String(endDate.getUTCMonth() + 1).padStart(2, '0');
        const day = String(endDate.getUTCDate()).padStart(2, '0');
        endDay = `${year}-${month}-${day}`;
    }
    else {
        const match = String(endDate).match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (!match) return false;
        endDay = `${match[1]}-${match[2]}-${match[3]}`;
    }

    const now = new Date();
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    return today > endDay;
}
